import { useState } from 'react';
import { TransactionFormData } from '@/types';

interface UseTransactionFormStateProps {
  initialData?: any;
}

export const useTransactionFormState = ({ initialData }: UseTransactionFormStateProps) => {
  // Função para obter data atual local sem conversões de timezone
  const getTodayLocalString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState<TransactionFormData>({
    description: initialData?.description || '',
    amount: initialData?.amount || 0,
    categoryId: initialData?.categoryId || '',
    date: initialData?.date || getTodayLocalString(), // Usar função simplificada
    type: (initialData?.type as 'receita' | 'despesa') || 'despesa',
    account: initialData?.account || '',
    accountId: initialData?.accountId || '',
    paymentMethod: (initialData?.paymentMethod as 'pix' | 'dinheiro' | 'cartao' | 'boleto' | 'transferencia') || 'pix',
    cardId: initialData?.cardId || '',
    isInstallment: initialData?.isInstallment || false,
    installments: initialData?.installments || 2,
    installmentDescription: initialData?.installmentDescription || '',
    status: initialData?.status || 'paid'
  });

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [amountString, setAmountString] = useState(
    initialData?.amount ? Math.abs(parseFloat(initialData.amount)).toString() : ''
  );

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    amountString,
    setAmountString
  };
};

// Export as default export for compatibility
export default useTransactionFormState;